const SET_CHART = 'SET_CHART';
const SET_STATS = 'SET_STATS';

export function setChart (chart) {
  return {
    type: SET_CHART,
    chart,
  }
}

export function setStats (stats) {
  return {
    type: SET_STATS,
    stats,
  }
}


const initialState = {
  chart: [],
  stats: { hasStats: false },
};

export default function results (state = initialState, action) {
  switch (action.type) {
    case SET_CHART:
      return {
        ...state,
        chart: action.chart
      };
    case SET_STATS:
      return {
        ...state,
        stats: {
          ...action.stats,
          hasStats: true,
        },
      };
    default:
      return state;
  }
}

// totalReturnPercentageTraditional, 
//     totalReturnPercentageEnhanced, 
//     totalReturnDollarsTraditional, 
//     totalReturnDollarsEnhanced,
//     annualizedReturnPercentageTraditional,
//     annualizedReturnPercentageEnhanced,
//     annualizedReturnDollarsTraditional,
//     annualizedReturnDollarsEnhanced,
//     sharpeTraditional,
//     sharpeEnhanced,
//     maxDrawDownTraditional, 
//     maxDrawDownEnhanced,


// WEBPACK FOOTER //
// ./src/reducers/results.js